import { Box, Grid } from "@mui/material"
import MenuTab from "../../../component/tabs/MenuTab"
import RicetteForm from "./RicetteForm"

// import StabilimentoForm from "./StabilimentoForm/StabilimentoForm"
// import SubImposteForm from "../Imposte/SubImposteForm"

const Ricette = ({ Component }) => {
    return (
        <>
            <div className="pageTemplate">

                <Grid container spacing={3}>
                    <Grid  size={{lg:3, md:4, xs:12}}>
                        <RicetteForm />
                    </Grid>
                    <Grid  size={{lg:9, md:8, xs:12}}>
                        <Box className="TemplateForm__right">
                            <MenuTab ricette={true} />
                        </Box>
                        {Component && <Component />}
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default Ricette
